import React, { useEffect, useState } from "react"
import {
  nePasManquerWrapper,
  nePasManquerContainer,
  nePasManquerTitle,
  nePasManquerResume,
  editButtonTitle,
} from "./ne-pas-manquer.module.scss"
import PropTypes from "prop-types"
import { Title, Wrapper } from "./ne-pas-manquer-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import NePasManquerItem from "./NePasManquerItem/ne-pas-manquer-item"
import { useNePasManquer } from "gatsby-theme-blank/src/components/Home/NePasManquer/ne-pas-manquer-query"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"

//-----------------------Parent component---------------------------//

const ListNePasManquer = () => {
  const data = useNePasManquer()
  const [finalData, setFinalData] = useState([])

  useEffect(() => {
    setFinalData(getPublishedData(data.allNodePage.edges))
  }, [data])

  if (finalData.length === 0) {
    return null
  }
  return (
    <Wrapper className={nePasManquerWrapper}>
      <Title className={nePasManquerTitle}>
        <EditButton
          addedClass={editButtonTitle}
          link={
            "/taxonomy/term/" +
            data.taxonomyTermZoneDefinie.drupal_internal__tid +
            "/edit"
          }
        />
        {data.taxonomyTermZoneDefinie?.field_label || "À ne pas manquer"}
      </Title>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={nePasManquerResume}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <ul className={nePasManquerContainer}>
        <RenderNePasManquer nePasManquerData={finalData} />
      </ul>
    </Wrapper>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Child component---------------------------//

const RenderNePasManquer = ({ nePasManquerData }) => {
  return nePasManquerData.map(({ node }) => {
    return <NePasManquerItem key={node.drupal_id} nePasManquer={node} />
  })
}

//-----------------------Child component---------------------------//

//-----------------------Prop-Types---------------------------//

RenderNePasManquer.propTypes = {
  nePasManquerData: PropTypes.object.isRequired,
}
//-----------------------Prop-Types---------------------------//

export default ListNePasManquer
